/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_L1_SubtitleInputs */

const en_visa_l1_subtitle = /** @type {(inputs: Visa_L1_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`INTRACOMPANY TRANSFEREE`)
};

const pt_visa_l1_subtitle = /** @type {(inputs: Visa_L1_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TRANSFERÊNCIA INTRAEMPRESARIAL`)
};

const es_visa_l1_subtitle = /** @type {(inputs: Visa_L1_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TRANSFERENCIA INTRAEMPRESARIAL`)
};

/**
* | output |
* | --- |
* | "INTRACOMPANY TRANSFEREE" |
*
* @param {Visa_L1_SubtitleInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_l1_subtitle = /** @type {((inputs?: Visa_L1_SubtitleInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_L1_SubtitleInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_l1_subtitle(inputs)
	if (locale === "es") return es_visa_l1_subtitle(inputs)
	return en_visa_l1_subtitle(inputs)
});